import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import TextInput from "../Common/TextInput";
import CustomButton from "../Common/CustomButton";
import { theme } from "../../Assets/Theme/theme";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../Assets/Constants";
import { toast } from "react-toastify";

function RegisterForm() {
  const [formData, setFormData] = useState({
    user: "",
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState([])
  const [isHovered, setIsHovered] = useState(false);
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate();

  const handleChange = (field, value) => {
    setFormData((prevData) => ({ ...prevData, [field]: value }));
  };

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const response = await axios.post(`${BASE_URL}/register`, formData, {
        withCredentials: true,
      });
      if (response.status === 201) {
        toast.success("Registration successful!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: { backgroundColor: 'orange', color: 'white' },
        });
        navigate("/login");
      } else if (response?.data?.error) {
        setErrors(response?.data?.error)
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(`${error?.response?.data?.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        setErrors(error?.response?.data?.error)
      }
    } finally {
      setLoading(false)
    }
  };

  const getErrorMessage = (field) => {
    const fieldError = errors?.find((err) => err?.path === field);
    return fieldError?.msg || null;
  };

  const clearErrorMessage = (field) => {
    setErrors((prevErrors) => prevErrors.filter((err) => err?.path !== field));
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        handleSubmit()
      }
    };

    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [formData]);

  return (
    <Box
      width={"60%"}
      margin={"0 auto"}
      sx={{
        "@media (max-width:900px)": {
          width: "80%",
        },
      }}
    >
      <Box>
        <TextInput
          label={"User Name"}
          placeholder={"Enter Your Name..."}
          type={"user"}
          value={formData.user}
          onChange={(e) => {
            handleChange("user", e.target.value)
            clearErrorMessage("user");
          }}
        />
        {getErrorMessage("user") && (
          <Box color="red" mb={2}>
            {getErrorMessage("user")}
          </Box>
        )}
        <TextInput
          label={"Email"}
          placeholder={"Enter Your Email..."}
          type={"email"}
          value={formData.email}
          onChange={(e) => {
            handleChange("email", e.target.value)
            clearErrorMessage("email");
          }}
        />
        {getErrorMessage("email") && (
          <Box color="red" mb={2}>
            {getErrorMessage("email")}
          </Box>
        )}
        <TextInput
          label={"Password"}
          placeholder={"Enter Your Password..."}
          type={"password"}
          value={formData.password}
          onChange={(e) => {
            handleChange("password", e.target.value)
            clearErrorMessage("password");
          }}
        />
        {getErrorMessage("password") && (
          <Box color="red" mb={2}>
            {getErrorMessage("password")}
          </Box>
        )}
        <CustomButton onClick={handleSubmit}>
          {loading ? <CircularProgress size={30} sx={{ color: "white" }} /> : 'Sign Up'}
          </CustomButton>
      </Box>
      <Box textAlign={"center"} marginTop={8} color={theme.colors.text}>
        Already have an account?{" "}
        <span
          style={{
            color: theme.colors.orange,
            fontWeight: "600",
            fontSize: 17,
            cursor: "pointer",
            textDecoration: isHovered ? "underline" : "none",
          }}
          onClick={() => navigate("/login")}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          Login
        </span>
      </Box>
    </Box>
  );
}

export default RegisterForm;
